import { reportBackgroundColor, reportColor } from "../../utils/report-color";
import { reportLogo } from "../../utils/report-logo";
import { reportTitle } from "../../utils/report-title";
// @ts-ignore
import logooutlined from "../../../../../public/assets/icons/logooutlined.svg";
import { ServiceType } from "@agroyaar/sdk";

interface HeaderProps {
  serviceType: ServiceType;
}

const Header = ({ serviceType }: HeaderProps) => {
  const reportBackground = reportBackgroundColor(serviceType);
  const reportColorCode = reportColor(serviceType);
  const headerTitle = reportTitle(serviceType);
  const srcLogo = reportLogo(serviceType);

  return (
    <div className="flex flex-col items-center gap-[8rem] w-full h-[130px] font-IRANSansX">
      <div className="relative w-full flex bg-white mb-[128px]">
        <span className="absolute top-[10px] left-[8px] text-white font-medium text-[12px] z-[99]">
          W W W . A G R O Y A A R . C O M
        </span>
        <span
          className={`absolute top-0 left-0 w-full h-[80px] rounded-br-[1300px] `}
          style={{ background: reportBackground }}
        />

        <div className="absolute w-[90%] top-[34px] right-[8px] flex justify-between items-center p-[12px] gap-[12px] rounded-[10px] border border-[rgba(255,255,255,0.6)]  glassshadow">
          <div className="flex items-center gap-[12px]">
            <img src={srcLogo} alt="logo" className="h-[40px]" />
            <span
              className="font-bold text-[24px]"
              style={{ color: reportColorCode }}
            >
              {headerTitle}
            </span>
          </div>

          <div className="flex items-center gap-[12px] pl-[2px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#028442] font-extrabold text-[20px] font-IRANSansX">
                اگــــــــرویـــــار
              </span>
              <span className="text-[#028442] font-extrabold text-[9px]">
                پلتفرم جامع خدمات کشاورزی
              </span>
            </div>
            <img src={logooutlined} alt="logo" className="h-[62px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
